import { render, staticRenderFns } from "./BoxPlotChart.vue?vue&type=template&id=32311efb&scoped=true"
import script from "./BoxPlotChart.vue?vue&type=script&lang=js"
export * from "./BoxPlotChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32311efb",
  null
  
)

export default component.exports